import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialCommitteeMemberRoleState: Dtos.CommitteeMemberRole & IRegistrationFormState = {
    id: null,
    committeeId: null,
    committee: null,
    personnelId: null,
    personnel: null,
    positionNo: null,
    committeeMemberRoleTypeId: null,
    committeeMemberRoleType: null,
    dateStarted: null,
    dateCeased: null,
    comment: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface ICommitteeMemberRoleReduxFormState {
    id: IFieldState<number>,
    committeeId: IFieldState<number>,
    personnelId: IFieldState<number>,
    positionNo: IFieldState<number>,
    committeeMemberRoleTypeId: IFieldState<number>,
    dateStarted: IFieldState<string>,
    dateCeased: IFieldState<string>,
    comment: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
